import { Injectable, signal, computed, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MapTourService {
  private router = inject(Router);

  /** Whether the auto tour mode is active (default 10s interval cycling) */
  readonly isTourActive = signal<boolean>(false);

  /** Tour cycle interval in seconds (default: 10 seconds) */
  readonly intervalSeconds = signal<number>(10);
  readonly intervalMs = computed(() => this.intervalSeconds() * 1000);

  /** Whether current page is the elevator map page */
  readonly isMapPage = signal<boolean>(false);

  constructor() {
    // Initial check
    this.updateIsMapPage(this.router.url);

    // Track route changes
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event) => {
      this.updateIsMapPage(event.urlAfterRedirects || event.url);
    });
  }

  private updateIsMapPage(url: string) {
    const isMap = url.includes('/elevator-map');
    this.isMapPage.set(isMap);
    if (!isMap && this.isTourActive()) {
      this.isTourActive.set(false);
    }
  }

  public toggleTour() {
    this.isTourActive.update(active => !active);
  }

  public stopTour() {
    this.isTourActive.set(false);
  }

  public setIsMapPage(isMap: boolean) {
    this.isMapPage.set(isMap);
    if (!isMap && this.isTourActive()) {
      this.stopTour();
    }
  }
}
